/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const LowIntensityIcon = props => {
	const { color = '' } = props
	return (
		<svg
			id='Layer_1'
			xmlns='http://www.w3.org/2000/svg'
			x={0}
			y={0}
			viewBox='0 0 24 24'
			style={{
				enableBackground: 'new 0 0 24 24'
			}}
			xmlSpace='preserve'
			width='1em'
			height='1em'
			{...props}
		>
			<style>{`.st034{fill: ${color}}.st12345{fill:#fff}`}</style>
			<path
				className='st034'
				d='M7.2 10.8v-.5C6.9 9.2 6 8.4 4.8 8.4H2.4C1.1 8.4 0 9.5 0 10.8v4.8C0 16.9 1.1 18 2.4 18h2.4c1.1 0 2.1-.8 2.3-1.9v-5.3z'
			/>
			<g id='Rectangle_3901'>
				<path
					className='st12345'
					d='M3.8.6h2.4C7.5.6 8.6 1.7 8.6 3v9.6c0 1.3-1.1 2.4-2.4 2.4H3.8c-1.3 0-2.4-1.1-2.4-2.4V3C1.4 1.7 2.5.6 3.8.6z'
					transform='translate(7 3)'
				/>
				<path
					className='st034'
					d='M6.2 15H3.8c-1.3 0-2.4-1.1-2.4-2.4V3C1.4 1.7 2.5.6 3.8.6h2.4C7.5.6 8.6 1.7 8.6 3v9.6c0 1.3-1.1 2.4-2.4 2.4zM3.8 1.8c-.7 0-1.2.5-1.2 1.2v9.6c0 .7.5 1.2 1.2 1.2h2.4c.7 0 1.2-.5 1.2-1.2V3c0-.7-.5-1.2-1.2-1.2H3.8z'
					transform='translate(7 3)'
				/>
			</g>
			<g id='Rectangle_3902'>
				<path
					className='st12345'
					d='M5.2 0h2.4C8.9 0 10 1.1 10 2.4v13.2c0 1.3-1.1 2.4-2.4 2.4H5.2c-1.3 0-2.4-1.1-2.4-2.4V2.4C2.8 1.1 3.9 0 5.2 0z'
					transform='translate(14)'
				/>
				<path
					className='st034'
					d='M7.6 18H5.2c-1.3 0-2.4-1.1-2.4-2.4V2.4C2.8 1.1 3.9 0 5.2 0h2.4C8.9 0 10 1.1 10 2.4v13.2c0 1.3-1.1 2.4-2.4 2.4zM5.2 1.2c-.7 0-1.2.5-1.2 1.2v13.2c0 .7.5 1.2 1.2 1.2h2.4c.7 0 1.2-.5 1.2-1.2V2.4c0-.7-.5-1.2-1.2-1.2H5.2z'
					transform='translate(14)'
				/>
			</g>
			<path
				className='st034'
				d='M24 21.6c0-.3-.3-.6-.6-.6H5.9c-.3-1-1.2-1.8-2.3-1.8-1.1 0-2 .8-2.3 1.8H.6c-.3 0-.6.3-.6.6s.3.6.6.6h.7c.3 1 1.2 1.8 2.3 1.8 1.1 0 2-.8 2.3-1.8h17.5c.3 0 .6-.3.6-.6zM685 436.3v-.4c-.2-.9-1-1.6-1.9-1.6h-2c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h2c.9 0 1.7-.7 1.9-1.6v-4.4z'
			/>
			<g id='Rectangle_3901_00000045610909089413913330000009576213099884538281_'>
				<path
					className='st12345'
					d='M681 427.3h2c1.1 0 2 .9 2 2v8c0 1.1-.9 2-2 2h-2c-1.1 0-2-.9-2-2v-8c0-1.1.9-2 2-2z'
					transform='translate(7 3)'
				/>
				<path
					className='st034'
					d='M683 439.3h-2c-1.1 0-2-.9-2-2v-8c0-1.1.9-2 2-2h2c1.1 0 2 .9 2 2v8c0 1.1-.9 2-2 2zm-2-11c-.6 0-1 .4-1 1v8c0 .6.4 1 1 1h2c.6 0 1-.4 1-1v-8c0-.6-.4-1-1-1h-2z'
					transform='translate(7 3)'
				/>
			</g>
			<g id='Rectangle_3902_00000054965330392453066550000015734879322030028455_'>
				<path
					className='st12345'
					d='M681 427.3h2c1.1 0 2 .9 2 2v11c0 1.1-.9 2-2 2h-2c-1.1 0-2-.9-2-2v-11c0-1.1.9-2 2-2z'
					transform='translate(14)'
				/>
				<path
					className='st034'
					d='M683 442.3h-2c-1.1 0-2-.9-2-2v-11c0-1.1.9-2 2-2h2c1.1 0 2 .9 2 2v11c0 1.1-.9 2-2 2zm-2-14c-.6 0-1 .4-1 1v11c0 .6.4 1 1 1h2c.6 0 1-.4 1-1v-11c0-.6-.4-1-1-1h-2z'
					transform='translate(14)'
				/>
			</g>
			<path
				className='st034'
				d='M699 445.3c0-.3-.2-.5-.5-.5h-14.6c-.2-.8-1-1.5-1.9-1.5-.9 0-1.7.6-1.9 1.5h-.6c-.3 0-.5.2-.5.5s.2.5.5.5h.6c.2.9 1 1.5 1.9 1.5.9 0 1.7-.6 1.9-1.5h14.6c.3 0 .5-.3.5-.5z'
			/>
		</svg>
	)
}

export default LowIntensityIcon
